import React from 'react';
import Modal from '../../../../shared/modal';

interface ConfirmActionModalProps {
    open: boolean;
    title: string;
    description: React.ReactNode;
    confirmLabel: string;
    loading?: boolean;
    destructive?: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

const ConfirmActionModal = ({
    open,
    title,
    description,
    confirmLabel,
    loading,
    destructive,
    onClose,
    onConfirm,
}: ConfirmActionModalProps) => {
    return (
        <Modal open={open} onClose={onClose} title={title} contentContainerStyle='w-full max-w-[480px]'>
            <div className='text-sm text-gray-600 dark:text-gray-300 mt-2 space-y-2'>{description}</div>
            <div className='mt-6 flex justify-end gap-3'>
                <button
                    type='button'
                    onClick={onClose}
                    className='px-4 py-2 rounded-md border border-gray-300 dark:border-gray-700 text-sm'
                >
                    Cancel
                </button>
                <button
                    type='button'
                    disabled={loading}
                    onClick={onConfirm}
                    className={`px-4 py-2 rounded-md text-sm text-white disabled:opacity-60 ${
                        destructive ? 'bg-red-600 hover:bg-red-700' : 'bg-primary-default'
                    }`}
                >
                    {loading ? 'Working...' : confirmLabel}
                </button>
            </div>
        </Modal>
    );
};

export default ConfirmActionModal;
